import * as React from "react";
import KuikaButton from "../ui-kit/kuika-button/kuika-button";
import { KuikaFormField } from "../ui-kit/kuika-form-page/kuika-form-page";
import KuikaInput from "../ui-kit/kuika-input/kuika-input";
import KuikaSvg from "../ui-kit/kuika-svg/kuika-svg";

export interface ISignInDividerProps {
  label?: string;
}

/** The "or" between a one-click provider and the credentials form, drawn as a rule with a gap. */
export const SignInDivider = ({ label = "or" }: ISignInDividerProps): React.ReactElement => (
  <div className="auth-page__divider">
    <span className="auth-page__divider-label">{label}</span>
  </div>
);

export interface ISignInPasswordFieldProps {
  disabled?: boolean;
  autoFocus?: boolean;
  onForgotPassword: () => void;
}

/**
 * The password field every sign-in path shares: its label row carries "Forgot password?", where
 * people look for it the moment the password fails, and the kit's reveal toggle shows the text.
 */
export const SignInPasswordField = ({
  disabled,
  autoFocus,
  onForgotPassword
}: ISignInPasswordFieldProps): React.ReactElement => (
  <KuikaFormField
    name="password"
    label="Password"
    requiredMarker={false}
    errorTestId="signInPasswordError"
    rules={[{ required: true, message: "Please enter your password" }]}
    labelAction={
      <KuikaButton
        type="text"
        size="sm"
        htmlType="button"
        onClick={onForgotPassword}
        className="auth-page__inline-action"
        data-testid="forgotPasswordButton"
      >
        Forgot password?
      </KuikaButton>
    }
  >
    <KuikaInput
      type="password"
      revealable
      size="lg"
      leftIcon={<KuikaSvg name="lock" />}
      placeholder="Enter your password"
      autoComplete="current-password"
      autoFocus={autoFocus}
      disabled={disabled}
      data-testid="signInPasswordInput"
    />
  </KuikaFormField>
);
